<script setup lang="ts">
import type { FieldState } from '@/utils/field-state'
import { useI18n } from 'vue-i18n'

withDefaults(
  defineProps<{
    label: string
    inputId?: string
    required?: boolean
    state?: FieldState | null
    source?: string
    hint?: string
  }>(),
  {
    inputId: undefined,
    required: false,
    state: null,
    source: undefined,
    hint: '',
  },
)

const { t } = useI18n({ useScope: 'local' })
</script>

<template>
  <div>
    <label class="field-label" :class="{ 'flex items-baseline gap-2': $slots.meta }" :for="inputId">
      <span class="min-w-0">
        {{ label }}<span v-if="required" class="text-danger" aria-hidden="true">*</span>
        <span v-if="required" class="sr-only">{{ t('required') }}</span>
      </span>

      <span v-if="$slots.meta" class="ml-auto shrink-0">
        <slot name="meta" />
      </span>
    </label>

    <slot />

    <p v-if="state === 'auto' && source" class="text-action mt-1 flex items-center gap-1.5 text-xs">
      <i class="pi pi-file-o text-[11px]" aria-hidden="true" />
      {{ t('fromSource', { source }) }}
    </p>

    <p v-if="hint" class="text-ink-3 mt-1 text-xs">{{ hint }}</p>
  </div>
</template>

<i18n lang="json">
{
  "de": {
    "required": "Pflichtfeld",
    "fromSource": "Aus {source}"
  },
  "en": {
    "required": "Required",
    "fromSource": "From {source}"
  }
}
</i18n>
